import { FormOptions, wrapForm } from 'components/shared/form';

import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';

import { ResidentialRentCompsWithCompplex } from './ResidentialRentComps';

const formConfig: FormOptions = {
  fields: [
    {
      name: 'incomeApproach',
      fields: [
        {
          name: 'residential',
          fields: [
            {
              name: 'rentComps',
              fields: [
                {
                  name: 'comps',
                  type: 'array',
                  value: [],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

export default wrapForm(formConfig)(ResidentialRentCompsWithCompplex);
